import React from 'react';
import CouponWrapper from './coupon/CouponWrapper.jsx';
import ShippingChargesSection from '@checkout/components/cart/ShippingChargesSection.jsx';
import {Button, Grid, Link, Spinner, Typography} from '@bonprix/design-system';

export default function CartSummary({
                                        cart,
                                        texts,
                                        calculating,
                                        footerText,
                                        onAddCoupon,
                                        onDeleteCoupon,
                                        couponPending,
                                        couponError,
                                        onCouponInput,
                                        onCartButtonClick,
                                        loading,
                                        disableOrderButton = false,
                                        disableCartToCheckoutButton = false,
                                        isLastCheckPage,
                                        isParcelShopDeliveryPossible,
                                        page,
                                        tosUrl
                                    }) {
    let largeItemPrice = null;
    let discount = null;
    let installmentRate = null;

    if (cart.summary.largeItemPrice) {
        largeItemPrice = (
            <div className="mt-2.5 flex justify-between items-center">
                <Typography component="span">{texts.cot09_large_piece_charge}</Typography>
                <Typography variant="h4" component="span" align="right">{cart.summary.largeItemPrice}</Typography>
            </div>
        );
    }

    if (cart.summary.discount) {
        discount = (
            <div className="cart__order-discount items-baseline flex">
                <div className="flex-grow-0 flex-shrink-0 basis-[55%]">
                    <Typography component="span">{texts.backend_sap_expense_rabatte || 'Discount'}</Typography>
                </div>
                <div className="text-right mt-2 flex-grow-0 flex-shrink-0 basis-[45%]">
                    <Typography variant="h4" component="span" align="right">{cart.summary.discount}</Typography>
                </div>
            </div>
        );
    }

    if (cart.summary.installmentRate) {
        installmentRate = (
            <div className="cart__installment-rate items-baseline flex">
                <div className="flex-grow-0 flex-shrink-0 basis-[55%]">
                    <Typography component="span">{texts.backend_sap_expense_ratenaufschlag}</Typography>
                </div>
                <div className="text-right mt-2 flex-grow-0 flex-shrink-0 basis-[45%]">
                    <Typography variant="h4" component="span" align="text">{cart.summary.installmentRate}</Typography>
                </div>
            </div>
        );
    }

    const isCartButtonNextDisabled = () => {
        return ((disableOrderButton && isLastCheckPage) || disableCartToCheckoutButton) || calculating;
    };

    return (
        <Grid>
            <Grid.Item s={0} l={6} />
            <Grid.Item s={12} l={6}>

                <div className="mb-6" test-ref__cart-order-voucher="">
                    <CouponWrapper
                        texts={texts}
                        coupon={cart.coupon}
                        onAddCoupon={onAddCoupon}
                        onDeleteCoupon={onDeleteCoupon}
                        pending={couponPending}
                        couponError={couponError}
                        onCouponInput={onCouponInput}
                        cvpCode={cart.cvpCode}
                        isLastCheckPage={isLastCheckPage}
                        page={page}
                    />
                </div>

                <div className="cart__order-price-summary">
                    <div className="flex flex-wrap flex-row items-baseline ">
                        <div className="flex-grow-0 flex-shrink-0 basis-[55%]">
                            <Typography variant="h4" component="h2">{texts.bp_bestellwert}</Typography>
                        </div>
                        <div className="flex-grow-0 flex-shrink-0 basis-[45%] text-right"
                             test-ref__cart-order-value-price="">
                            <Typography variant="h3" component="span" align="right">{cart.summary.cartPrice}</Typography>
                        </div>
                    </div>

                    <ShippingChargesSection
                        isParcelShopDeliveryPossible={isParcelShopDeliveryPossible}
                        texts={texts}
                        shippingCharges={cart.summary.shippingCharges} />

                    {largeItemPrice}
                    {discount}
                    {installmentRate}


                    <div className="cart__divider-total-sum" />


                    <div className="flex justify-between">
                            <Typography variant="h4" component="h2">{texts.wk_gesamtsumme}</Typography>
                            <Typography variant="h3" component="span" align="right">{cart.summary.orderPrice}</Typography>
                    </div>

                    <div className="mt-0.25">
                        <Typography component="span">{texts.mobile_cot09_4_VAT}</Typography>
                    </div>
                    {calculating && (
                        <div className="cart__order-price-summary__spinner-container">
                            <Spinner edgeLength="4.5rem" />
                        </div>
                    )
                    }
                </div>
                {isLastCheckPage && (
                    <div className="flex flex-wrap mt-5">
                        <Typography>{texts.checkout__tos_and_cancellation_1}&nbsp;</Typography>
                        <Link href={tosUrl} target="_blank">{texts.checkout__tos_and_cancellation_2}</Link>
                        <Typography>&nbsp;{texts.checkout__tos_and_cancellation_3}&nbsp;</Typography>
                        <Link href={tosUrl} target="_blank">{texts.checkout__tos_and_cancellation_4}</Link>.
                    </div>
                )}
                <div className="flex flex-col w-full mt-8">
                    <Button
                        id={'test-ref__cart-button-next'}
                        className="cart__summary-button-next"
                        icon="arrow-right"
                        iconPosition="end"
                        disabled={isCartButtonNextDisabled()}
                        onClick={onCartButtonClick}
                        loading={loading}
                    >
                        {footerText || texts.cot09_wk_proceed_to_checkout}
                    </Button>
                </div>
            </Grid.Item>
        </Grid>
    );
}
